import { Directive, computed, input } from '@angular/core'

import { isOpaqueColour, parseColourValue } from '@flowx/core-theme'

/** Paints a colour swatch, with a checkerboard (global `.flx-checkerboard`) behind a translucent colour. */
@Directive({
  selector: '[flxColourSwatch]',
  host: {
    '[class.flx-checkerboard]': 'translucent()',
    '[style.--flx-swatch-colour]': 'translucent() ? flxColourSwatch() : null',
    '[style.background-color]': 'translucent() ? null : flxColourSwatch()',
  },
})
export class FlxColourSwatchDirective {
  protected readonly translucent = computed(() => {
    const colourValue = parseColourValue(this.flxColourSwatch() ?? '')
    return colourValue !== null && !isOpaqueColour(colourValue)
  })

  flxColourSwatch = input<string | null | undefined>()
}
